import React from "react";
import "react-slideshow-image/dist/styles.css";
import { useTranslation } from "react-i18next";

import Slider from "./Slider";

export const SessionOptions = ({
  slideImages,
  selectedgrp,
  setselectedgrp,
  availableGroups = [],
  onPlayerNewSession = null,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="metrics">
        <div className="metrics-info home-info">
          <h3>{t("traininggrp")}</h3>
        </div>
      </div>

      {slideImages && (
        <Slider
          images={slideImages}
          selectedgrp={selectedgrp}
          setselectedgrp={setselectedgrp}
          availableGroups={availableGroups}
          onPlayerNewSession={onPlayerNewSession}
        />
      )}
    </>
  );
};
